import { useContext } from "react";
import { AbilityContext } from "../context/abilityContext";
import type { AbilityContextType } from "../types/types";

export function useAbility(): AbilityContextType {
  const context = useContext(AbilityContext);
  if (context === undefined) {
    throw new Error("useAbility must be used within an AbilityProvider");
  }
  return context;
}

export function useCan() {
  const { ability } = useAbility();
  return ability;
}
